function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="28" height="32" viewBox="0 0 28 32" {...props}><title>icon-flag</title><path fill="#fff" d="M.141 4.045v-.19h32V28.14H.236l12.333-12.143L.142 4.045z" /></svg>;
});